import { Component, Inject, OnInit, OnDestroy, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';

import { ActivatedRoute, NavigationEnd, Router, RouterOutlet } from "@angular/router";
import { filter, map } from "rxjs/operators";
import { Subscription } from "rxjs";
import { TalespinnerGoogleAnalyticsService } from "./core/services/talespinner-google-analytics.service";
import { SeoService } from "./core/services/seo.service";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    imports: [RouterOutlet]
})
export class AppComponent implements OnInit, OnDestroy {
  private subs: Subscription;

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private gaService: TalespinnerGoogleAnalyticsService,
    private seoService: SeoService,
    @Inject(PLATFORM_ID) private platformId: object
  ) {}

  ngOnInit() {
    this.setupDynamicSEO();
    if (isPlatformBrowser(this.platformId)) {
      this.addAnalytics();
    }
  }

  private setupDynamicSEO() {
    this.router.events.pipe(
      filter((event) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map((route) => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter((route) => route.outlet === 'primary')
    ).subscribe((route) => {
      this.seoService.apply(route.snapshot.data['seo'], this.router.url);
    });
  }

  private addAnalytics() {
    const sanitizeUrl = (url: string): string => {
      return url.replace(/[a-f0-9]{8}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{4}-[a-f0-9]{12}/g, '{uuid}')
        .replace(/\d+/g, '{id}');
    };

    this.subs = this.router.events.pipe(
      filter((event: any) => event instanceof NavigationEnd),
      map(() => this.activatedRoute),
      map(route => {
        while (route.firstChild) route = route.firstChild;
        return route;
      }),
      filter(route => route.outlet === 'primary'),
      map(route => {
        const pageTitle = route.snapshot.data.title;
        const urlAfterRedirects = this.router.url;
        return {pageTitle, urlAfterRedirects};
      }),
      map(({urlAfterRedirects, pageTitle}) => {
        const sanitizedUrl = sanitizeUrl(urlAfterRedirects);
        return {sanitizedUrl, pageTitle};
      })
    ).subscribe(({sanitizedUrl, pageTitle}) => {
      if (pageTitle) {
        this.gaService.pageView(sanitizedUrl, pageTitle);
      } else {
        this.gaService.pageView(sanitizedUrl, "Talespinner");
      }
    });
  }

  ngOnDestroy() {
    if (this.subs) {
      this.subs.unsubscribe();
    }
  }
}
